<template>
  <v-dialog v-model="dialog" width="1000px">
    <v-card>
      <div class="iframe-container">
        <div class="d-flex flex-row print-btn">
          <v-btn
          class="mr-5"
            @click="printPageTry"
            color="secondary darken-1"
            style="color: white"
          >
            Yazdır
          </v-btn>
        
          <v-btn
            @click="closeDialog"
            color="danger darken-1"
            style="color: white"
          >
            KAPAT
          </v-btn>
        </div>
        <iframe
          class="receipt-iframe"
          id="frame"
          :srcdoc="receiptValue"
        ></iframe>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { numberConverter, printView } from "../../../helpers";
import { mapActions, mapState } from "vuex";
import { addBase64Prefix, logoFromConfig } from "@/base64Helper";
import { formattedDate } from "@/momentHelper";

export default {
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    receiptValue: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState("settings", ["generalSettings"]),
  },
  data() {
    return {
      dialog: false,
      date: null,
      selectedCurrent: null,
      description: null,
      amount: null,
      collectionNumber: null,
      type: null,
    };
  },
  methods: {
    numberConverter,
    formattedDate,
    logoFromConfig() {
      return logoFromConfig;
    },
    addBase64Prefix,
    printView,
    ...mapActions("current", ["fetchSingleCurrent"]),
    closeDialog() {
      this.dialog = false;
    },
    printPageTry() {
      document.getElementById("frame").contentWindow.print();
    },
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
      if (newVal) {
        newVal;
      }
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
  },
};
</script>

<style>
.iframe-container {
  width: 1000px;
  height: 730px;
  padding-top: 10px;
}

.receipt-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.print-btn {
  position: absolute;
  bottom: 10px;
  left: 40%;
  z-index: 10;
}
</style>
